import React, { useState, useEffect } from 'react';
import { IComponentEmpty } from '../../component';
import { RenderComponentWithWrapper, RenderComponentWithPCWrapper } from '../Gallery/RenderComponent';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import './index.scss';

const Empty = (props: IComponentEmpty) => {
  const { list, direction = 'column', gap, cid, rootStore } = props;
  const { pagedataStore } = props.rootStore!;
  const [currentDirection, setCurrentDirection] = useState(direction);

  useEffect(() => {
    if (rootStore?.pagedataStore.renderMode === 'pc') {
      const handleResize = () => {
        if (window.innerWidth < 768) {
          setCurrentDirection('column');
        } else {
          setCurrentDirection(direction);
        }
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [direction, rootStore]);

  const shouldShowMobile = currentDirection === 'column' && pagedataStore.renderMode === 'pc';

  if (!list) {
    return null;
  }
  
  return (
    <div className={`all-for-empty wrapper-direction-${currentDirection}`}>
      <style>{`
        .comp_${cid} .all-for-empty.wrapper-direction-row>* {margin-right:${gap}px !important}
        .comp_${cid} .all-for-empty.wrapper-direction-row>*:last-child {margin-right:0px !important}
      `}</style>
      {list.map(one => {
        if (pagedataStore.renderMode === 'pc') {
          return RenderComponentWithPCWrapper(one);
        } else {
          return RenderComponentWithWrapper(one);
        }
      })}
    </div>
  );
}

export default inject('rootStore')(observer(Empty));
